import { useState } from "react";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { auth, db } from "../firebase";
import { useNavigate } from "react-router-dom";

export default function UsernameSetup() {
  const [name, setName] = useState(auth.currentUser?.displayName || "");
  const nav = useNavigate();

  const save = async () => {
    const clean = name.trim().replace(/\s+/g, " ").slice(0, 32);
    if (!clean || !auth.currentUser) return;
    const user = auth.currentUser;
    const ref = doc(db, "users", user.uid);
    const existing = await getDoc(ref);
    await setDoc(ref, {
      ...(existing.exists() ? existing.data() : {}),
      displayName: clean,
      displayNameLower: clean.toLowerCase(),
      uid: user.uid,
      photoURL: user.photoURL || "",
      email: user.email || "",
      normalizedEmail: (user.email || "").toLowerCase().trim(),
    }, { merge: true });
    nav("/chat", { replace: true });
  };

  return (
    <main className="auth-shell">
      <section className="auth-box auth-box-modern setup-box">
        <div className="brand-mark small">✒</div>
        <h2>Choose your Pen name</h2>
        <p className="auth-subtitle">This is how people will see you in chats.</p>
        <input autoFocus value={name} maxLength={32} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && save()} placeholder="Your display name" />
        <button className="primary-button" onClick={save}>Continue</button>
      </section>
    </main>
  );
}
